"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getThemeValue;

var _get = _interopRequireDefault(require("lodash/get"));

var _propsEvalOrReturn = _interopRequireDefault(require("./propsEvalOrReturn"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function getThemeValue(key, defaultValue) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$theme = props.theme,
        theme = _props$theme === void 0 ? {} : _props$theme;
    var result = (0, _get["default"])(theme, key);

    if (result === undefined) {
      result = defaultValue;
    }

    return (0, _propsEvalOrReturn["default"])(result, props);
  };
}